export const iconFontAwesomeTimeCalendarWeek = (
	<i className="fa-solid fa-calendar-week"></i>
);
